import { createSlice } from '@reduxjs/toolkit';

import { RESCHEDULE_REASON_MODAL_STAGES } from '@classCreation/data/rescheduleReasonModalStages';

const initialState = {
  rescheduleModalStage: RESCHEDULE_REASON_MODAL_STAGES.notOpen,
  communications: {},
  selectedSbatGroup: null,
  newDateOfTopic: null,
  rescheduleReason: null,
  errors: null,
  rescheduleSbatGroupValidateErrorMessage: null,
};

export const rescheduleSbatGroup = createSlice({
  name: 'rescheduleSbatGroup',
  initialState,
  reducers: {
    setRescheduleModalStage: (state, action) => {
      state.rescheduleModalStage = action.payload;
    },
    setRescheduleCommunications: (state, action) => {
      state.communications[action.payload.channel] = action.payload.enabled;
    },
    setSelectedRescheduleSbatGroup: (state, action) => {
      state.selectedSbatGroup = action.payload;
    },
    setNewDateOfTopic: (state, action) => {
      state.newDateOfTopic = action.payload;
    },
    setRescheduleReason: (state, action) => {
      state.rescheduleReason = action.payload;
    },
    setRescheduleSbatGroupErrors: (state, action) => {
      state.errors = action.payload;
    },
    setRescheduleSbatGroupValidateErrorMessage: (state, action) => {
      state.rescheduleSbatGroupValidateErrorMessage = action.payload;
    },
    resetRescheduleModal: (state, _) => {
      state.rescheduleModalStage = RESCHEDULE_REASON_MODAL_STAGES.notOpen;
      state.communications = {};
      state.selectedSbatGroup = null;
      state.newDateOfTopic = null;
      state.rescheduleReason = null;
    },
  },
});

export const {
  resetRescheduleModal,
  setRescheduleCommunications,
  setRescheduleReason,
  setRescheduleModalStage,
  setSelectedRescheduleSbatGroup,
  setNewDateOfTopic,
  setRescheduleSbatGroupErrors,
  setRescheduleSbatGroupValidateErrorMessage,
} = rescheduleSbatGroup.actions;
export default rescheduleSbatGroup.reducer;
